<template>
    <user-view v-if="role == 'user'" />
    <other-roles-view v-else />
</template>

<script>
import UserView from "./UserView.vue";
import OtherRolesView from "./OtherRolesView.vue";

export default {
    name: "internship-clinical-placement",
    components: {
        UserView,
        OtherRolesView,
    },
    created() {
        if (!this.hasPermission('internship')) {
            this.$router.replace('/no-permission');
        }
    },
    computed: {
        role() {
            return this.$store.getters.role;
        },
    },
    methods: {
        hasPermission(crudName) {
            const permissions = this.$store.getters.permissions || '';
            const permissionsArray = permissions.split(",");
            return permissionsArray.includes(crudName);
        },
    }
}
</script>
